/*
 * @Author: songjingyang songjingyang@meishubao.com
 * @Date: 2025-03-28 15:40:04
 * @LastEditors: songjingyang songjingyang@meishubao.com
 * @LastEditTime: 2025-03-28 15:40:39
 * @FilePath: src/api/menu.ts
 * @Description: TypeScript版本 - 自动转换
 */

import request from '@/utils/request'

// 获取路由
export const getRouters = (): any => {
  return request({
    url: '/getRouters',
    method: 'get'
  })
}